// LocalStorage key names for the email-link (magic link) sign-in flow
export const EMAIL_FOR_SIGN_IN_KEY = "emailForSignIn";
export const POST_SIGNIN_REDIRECT_KEY = "postSigninRedirect";
